import { render } from "./navbar-desktop.vue?vue&type=template&id=a3470746&scoped=true"
import script from "./navbar-desktop.vue?vue&type=script&lang=js"
export * from "./navbar-desktop.vue?vue&type=script&lang=js"

import "./navbar-desktop.vue?vue&type=style&index=0&id=a3470746&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3470746"]])

export default __exports__